module.exports = __webpack_public_path__ + "SF-UI-Display-Bold.6991c865641a45a62e9c.otf";


//////////////////
// WEBPACK FOOTER
// D:/UI-PROJECTS/Helpline1097-UI/src/fonts/SF-UI-Display/SF-UI-Display-Bold.otf
// module id = ../../../../../src/fonts/SF-UI-Display/SF-UI-Display-Bold.otf
// module chunks = 2